import React from 'react';
import HomePage from './HomePage';

// Country-locked landing page for US Meta Ads — same HomePage content but
// the RegionContext is forced to `us` (USD pricing) and the currency toggle
// is hidden. The Register CTA carries `?region=us` so the new user lands in
// their correct region from day one.
const UsLandingPage = () => <HomePage lockedRegion="us" />;

export default UsLandingPage;
